// extracted by mini-css-extract-plugin
export default {"variantItem":"DefaultCheckInVariantSelect_variantItem__thjIM","variantItemText":"DefaultCheckInVariantSelect_variantItemText__J+iAw"};